var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "akl" },
    [
      _c("div", { staticClass: "bod-view-txt" }, [
        _vm.isSummaryView
          ? _c(
              "div",
              { staticClass: "os_noticeRes" },
              [
                _c("SurveyCompleted", {
                  attrs: { edit: _vm.editable },
                  on: {
                    edit: function($event) {
                      _vm.editable = true
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isSummaryView
          ? _c(
              "div",
              { staticClass: "os_noticeRes" },
              [
                _c(
                  "div",
                  { staticClass: "widM padTM cont_Wrap" },
                  [
                    _c("SurveyHeader"),
                    _vm._v(" "),
                    _vm.infoAvailable
                      ? [
                          _vm.isInitCompleted
                            ? _c("SurveyParticipantInfo")
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.existAttendant ? _c("SurveyConsent") : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.existAttendant && _vm.activityAvailable
                      ? _c("SurveyActivityList")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.existAttendant && _vm.activityAvailable
                      ? _c("SurveyReturnScheduleList")
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr", {
                      staticStyle: {
                        "border-top": "1px solid #ddd",
                        background: "#f4f4f4"
                      }
                    }),
                    _vm._v(" "),
                    _vm.isOpenSaveButton
                      ? _c("div", { staticClass: "widM txtC marTML" }, [
                          _c(
                            "button",
                            {
                              staticClass: "bt-akl-blue large pf23-submit",
                              class: {
                                NCAcmi_submitNope: _vm.submitBtnDisabled
                              },
                              attrs: { disabled: _vm.submitBtnDisabled },
                              on: { click: _vm.submitSurvey }
                            },
                            [_vm._v("신청하기")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOpenCancelButton
                      ? _c("div", { staticClass: "widM txtC marTML" }, [
                          _c(
                            "button",
                            {
                              staticClass: "bt-akl-blue large pf23-submit",
                              class: {
                                NCAcmi_submitNope: _vm.submitBtnDisabled
                              },
                              on: { click: _vm.cancelSurvey }
                            },
                            [_vm._v("신청취소")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "padM disIb" })
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.survey_popup
                  ? _c(
                      "SurveyPopupLayer",
                      [_c(_vm.popupComponent, { tag: "component" })],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("SurveyPopupLayerActivity", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.survey_activity_popup,
                      expression: "survey_activity_popup"
                    }
                  ]
                }),
                _vm._v(" "),
                _vm.survey_interestFee_popup
                  ? _c("SurveyPopupLayerInterestFee")
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.survey_loading ? _c("SurveyLoading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38454055", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38454055","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/singapore/Survey.vue
// module id = null
// module chunks = 